
import TableList from "@components/templates/tablelist";
import { HttpHttpAnalyzeDetailOne } from "@/service/fedex";
import { mapGetters } from "vuex";
export default {
	mixins: [TableList],
	data() {
		return {
			isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {},
            Searchs: {
                show: true,
                labelWidth: 110,
            },
			Plugins: { show: true },
			titles:[
				{label: this.$t('fbb.analyze.title4',{defaultValue:'总额差=成本核算总额-FedEx账单运费总额'})},
				{label: this.$t('fbb.analyze.title5',{defaultValue:'差额=账单-系统'})}
			]
		}
	},
	methods: {
		ajaxRequest: HttpHttpAnalyzeDetailOne,
		handleOperates(params = "", type, batch) {
			if (batch === true) {
				params = (params || this.checkedData.join(',')) + '';
				if (!params.length) return this.$VMessage.warning(this.$t('global.common.choose_one',{defaultValue:'请选择至少一条数据'}));
			}
			switch (type) {
				case 'export':
						this.handleWebfs(process.env.VUE_APP_APIURL_FBB + '/api/v2/expensesComparisonDetailed/export', this.formData, {
							executor: 'request',
							download: true,
							method: 'get',
						})
					break;
			}
		},
	},
	computed: {
		...mapGetters('dictionary', ['getBillcusorgList', 'getBillcusWareList', 'getCusproductList','getCarrierServiceList']),
		ToolsData() {
            return [
                {
					name: this.$t('global.common.export',{defaultValue:'导出'}),
					operate: "export",
					theme: "info",
				},
            ]
        },
		SearchsData(){
			return [{
				label: "Tracking No",
				tag: 'vInput',
				key: 'EQ_trackingNo',
				show: true,
			}, {
				label: this.$t('erp.b2border.invoice',{defaultValue:'发票号'}),
				tag: 'vInput',
				key: 'EQ_invoiceNo',
				show: true,
			}, {
				label: this.$t('fbb.bill.freeze_createdat',{defaultValue:'创建日期'}),
				tag: 'vDatepicker',
				style: "width:250px",
				key: 'BT_createdAt',
				show: true,
				props: {
					format: 'yy-mm-dd ~ yy-mm-dd',
					confirm: false,
				},
			},
			{
				label: this.$t('bi.work.task_org_id',{defaultValue:'组织'}),
				tag: 'vSelect',
				key: 'EQ_orgId',
				more: true,
				options: this.getBillcusorgList,
				props: {
					filterable: true,
				}
			},
			{
				label: this.$t('global.common.project',{defaultValue:'项目'}),
				tag: 'vSelect', 
				key: 'EQ_lineId',
				more: true,
				options: this.getCusproductList,
				props: {
					filterable: true,
				}
			},
			{
				label: this.$t('erp.b2c.product_orgwarehouse',{defaultValue:'仓库'}),
				tag: 'vSelect',
				key: 'EQ_orgWarehouseCode',
				options: this.getBillcusWareList.map(item=>{
					return {
						value: item.attach.code,
						label: item.label
					}
				}),
				props: {
					filterable: true,
				}
			},
			{
				label: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
				tag: 'vSelect',
				key: 'EQ_carrierServiceCode',
				more: true,
				options: this.getCarrierServiceList.map(item=>{
					return {
						value: item.attach.carrierServiceCode,
						label:item.label
					}
				}),
				props: {
					filterable: true,
				}
			},
			{
				label: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
				tag: 'vSelect',
				key: 'EQ_carrierCode',
				more: true,
				options: [
					{value:'FedEx',label:'FedEx'},
					{value:'UPS',label:'UPS'},
				],
				props: {
					filterable: true,
				}
			},
			{
				label: this.$t('fbb.analyze.iserrortype',{defaultValue:'是否异常'}),
				tag: 'vSelect',
				key: 'EQ_errorType',
				more: true,
				options: [
					{value:'1',label:this.$t('erp.global.yes',{defaultValue:'是'})},
					{value:'0',label:this.$t('erp.global.no',{defaultValue:'否'})},
				],
				props: {
					filterable: true,
				}
			},
		]
		},
		columns() {
			return [
				{
					title: "Tracking NO",
					key: 'trackingNo',
				},
				{
					title: this.$t('fbb.analyze.fedextotalnum',{defaultValue:'FedEx账单总数'})+'/'+this.$t('fbb.analyze.costtotalnum',{defaultValue:'成本核算总额'}),
					width:150,
					render:(h,{row})=>{
						return <div>
							{row.fedexTotalExpenses}
							<div>{row.costTotalExpenses}</div>
						</div>
					}
				},
				{
					// title: "总额差",
					renderHeader:(h,params)=>{
						return h('div',[
							h('vTooltip',{
								props:{
									placement:'top',
									transfer:true,
									content:this.titles[0].label
								}
							},[
								h('strong',this.$t('fbb.analyze.totaldifference',{defaultValue:'总额差'})),
								h('vIcon',{
									props:{
										type:"help-circle",
										color:"#ff9900",
										style:'font-size:20px;'
									},
								}),
							]),
							
							
						])
					},
					key: 'totalDifference',
					render: (h, { row }) => {
						const val = row.totalDifference
						return val < 0 ? <div class='color-error' >{val}</div > : <div class='color-success' > {val}</div>
					}
				},
				{
					title: this.$t('fbb.billDelivery.costName',{defaultValue:'收费项'}),
					key: 'costName',
				},
				{
					title: this.$t('fbb.analyze.fedexBaseCharges',{defaultValue:'FedEx账单'})+"/"+this.$t('fbb.analyze.costItemCharges',{defaultValue:'成本核算金额'}),
					width:150,
					// key: 'fedexItemCharges',
					render:(h,{row})=>{
						return <div>
							{row.fedexItemCharges}
							<div>{row.costItemCharges}</div>
						</div>
					}
				},
				{
					// title: "差额",
					renderHeader:(h,params)=>{
						return h('div',[
							h('vTooltip',{
								props:{
									placement:'top',
									transfer:true,
									content:this.titles[1].label
								}
							},[
								h('strong',this.$t('fbb.analyze.itemDifference',{defaultValue:'差额'})),
								h('vIcon',{
									props:{
										type:"help-circle",
										color:"#ff9900",
										style:'font-size:20px;'
									},
								}),
							]),
							
							
						])
					},
					key: 'itemDifference',
					render: (h, { row }) => {
						const val = row.itemDifference
						return val < 0 ? <div class='color-error' >{val}</div > : <div class='color-success' > {val}</div>
					}
				},
				{
					title: this.$t('erp.product_channel.currency',{defaultValue:'币种'}),
					key: 'currency',
				},
				{
					title: this.$t('bi.work.task_org_id',{defaultValue:'组织'})+'/'+this.$t('erp.b2c.product_orgwarehouse',{defaultValue:'仓库'})+'/'+this.$t('global.common.project',{defaultValue:'项目'}),
					width:120,
					render: (h, { row }) => {
						let orgWarehouseCode = row.orgWarehouseCode
						let orgWarehouse = this.getBillcusWareList.find(item=>{
							return item.attach.code == orgWarehouseCode
						})
						return <div>
							<div>{row.orgName}</div>
							{orgWarehouse ? orgWarehouse.label : '--'}
							<div>{row.lineName || '--'}</div>
						</div>
					}
				},
				{
					title: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'})+'/'+this.$t('erp.b2border.invoice',{defaultValue:'发票号'}),
					width:120,
					render:(h,{row})=>{
						return <div>
							{row.carrierServiceCode}
							<div>{row.invoiceNo}</div>
						</div>
					}
				},
				{
					title: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
					key: 'carrierCode',
				},
				{
					title: this.$t('fbb.analyze.iserrortype',{defaultValue:'是否异常'}),
					render(h,{row}){
						switch(row.errorType){
							case '1':return this.$t('erp.global.yes',{defaultValue:'是'});break;
							case '0':return this.$t('erp.global.no',{defaultValue:'否'});break;
						}
					}
				},
				{
					title: this.$t('global.common.createdtime',{defaultValue:'创建时间'}),
					key: 'createdAt',
				},

			]
		},
	}
}
